import axios from "axios";
import store from "@/stores/index.js";
import router from "@/router";  // Ensure the router is imported

const internalApi = axios.create({
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${store.state.auth.token}`,
    },
    timeout: 180000
});

const setAuthHeaders = () => {
    const token = store.state.auth.token;
    return {
        Accept: "application/json",
        Authorization: token ? `Bearer ${token}` : '',
    };
};

// Modify request URLs to use HTTPS
internalApi.interceptors.request.use(
    (config) => {
        config.headers = setAuthHeaders();
        store.commit('auth/setLoading', true);
        console.log('config.url : '+config.url)

        // Ensure the request URL uses HTTPS
        if (config.url.startsWith("https://") && !config.url.includes("127.0.0.1") && !config.url.includes("localhost")) {
            console.log('config.url : '+config.url)
            config.url = config.url.replace("http://", "https://");
        }

        return config;
    },
    (error) => {
        store.commit('auth/setLoading', false);
        return Promise.reject(error);
    }
);

internalApi.interceptors.response.use(
    (response) => {
        store.commit('auth/setLoading', false);
        return response;
    },
    async (error) => {
        const { status } = error.response || {};
        if (status === 401) {
            await store.dispatch('auth/logout');
            router.push('/');
        }
        if (status===403){
            console.log(error.response.data.code)
            if (error.response.data.code==='99'){
                window.location.replace('/auth-otp');
                return ;

            }else{
                console.log('code 403')
                // Update your store or component state here instead of redirect
                await router.push({
                    name: 'error-page',
                    query: {
                        code: 403,
                        message: 'You do not have permission to access this page.'
                    }
                });
            }

``


        }
        store.commit('auth/setLoading', false);
        return Promise.reject(error);
    }
);

export default internalApi;
